import { Chip, Grid, Avatar, IconButton, Box, CircularProgress } from '@mui/material'
import CameraAlt from '@mui/icons-material/CameraAlt'
import Edit from '@mui/icons-material/Edit'
import debounce from 'lodash/debounce'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { toast } from 'react-toastify'
import axios from 'axios'
import {
  setValueFromDotOperatorString as getUpdatedValueFromDotOperatorString,
  getValueFromDotOperatorString
} from 'src/shared/utils/objectPath'
import { StyledLabel } from 'src/consumer/components/helperComponentsStyles'
import { hasDuplicateStrings, genericHandleChange } from 'src/consumer/helpers/utilFunctions'
import { getMPDataWithoutParams, getMPDataWithParams } from 'src/mentor/services'
import { apiURL, commonHeadersWeb, mediaURL } from 'src/consumer/services'
import { getImageLink, isValidHttpUrl } from 'src/mentor/helpers/utilityFunctions'
import { ClinicOnboardingInputComponentWithHTMLProps } from '../ClinicOnboardingComponents'
import {
  BusinessOnboardingInput,
  BusinessOnboardingInputContainer,
  BusinessOnboardingSubmitButton,
} from '../ClinicOnboardingStyles'
import StaffOnboardingCards from './components/StaffOnboardingCards'
import { isValidEmail } from './components/utils'

const staffTypes = {
  admins: {
    id: 'prospects.admins',
    workForceId: 'workforce.admins',
    singleTitle: 'Admin',
    multiTitle: 'Admins',
  },
  doctor: {
    id: 'prospects.doctors',
    workForceId: 'workforce.doctors',
    singleTitle: 'Doctor',
    multiTitle: 'Doctors',
  },
  therapist: {
    id: 'prospects.therapists',
    workForceId: 'workforce.therapists',
    singleTitle: 'Therapist',
    multiTitle: 'Therapists',
  },
  clinicAssistant: {
    id: 'prospects.clinicAssistants',
    workForceId: 'workforce.clinicAssistants',
    singleTitle: 'Clinic Assistant',
    multiTitle: 'Clinic Assistants',
  },
}

export default function ClinicBrandOnboardingComponent({
  clinicBrand,
  setClinicBrand,
  ownerUserData,
  saveClinicBrand = () => {
    console.log('saveClinicBrand no method set')
  },
  clinicBrandLoading,
  editingPeopleNotAllowed,
  editingProfileDetailsNotAllowed,
  savingClinicBrand,
  ownerData,
  clinicBrandId,
  teacherData,
}) {
  const [staffsAddordionState, setStaffAccordionState] = useState(staffTypes?.doctor?.id)
  const [slugValidationLoading, setSlugValidationLoading] = useState(false)
  const [slugInvalidFormat, setSlugInvalidFormat] = useState(false)
  const [slugValid, setSlugValid] = useState(false)
  const [initialSlugValue, setInitialSlugValue] = useState('')
  const [brandOwnerUserData, setBrandOwnerUserData] = useState([ownerUserData])
  const [tempImgUrl, setTempImgUrl] = useState(null)
  const [waitingPictureUpload, setWaitingPictureUpload] = useState(false)

  const slugInputRef = useRef()
  const fileInputRef = useRef(null)

  const showTempSlug = !clinicBrand?.slug

  function handleChange(eve) {
    if (eve.target.id === 'brandName') {
      // debounceGetSuggestedSlug(eve.target.value)
    }

    genericHandleChange(eve, setClinicBrand)
  }

  async function validateSlug(currentSlug, initialSlugValue) {
    setSlugValid(false)
    setSlugInvalidFormat(false)
    setSlugValidationLoading(true)
    if (Boolean(currentSlug)) {
      const pattern = /^[a-z\-]+$/ // match only a-z and hyphen
      const matchesPattern = pattern.test(currentSlug)
      if (currentSlug === initialSlugValue) {
        setSlugValid(true)
      } else if (matchesPattern) {
        const response = await getMPDataWithoutParams(
          `/api/secure/cp/clinic-brand/slug/check-availability?slug=${currentSlug}`,
        )
        if (response?.status === 200) {
          if (response?.data) {
            setSlugValid(true)
          } else {
            setSlugValid(false)
          }
        } else {
          toast.error('Error checking slug availability')
        }
      } else {
        setSlugInvalidFormat(true)
        setSlugValid(false)
      }
    } else {
      setSlugInvalidFormat(true)
      setSlugValid(false)
    }
    setSlugValidationLoading(false)
  }

  const debSlugValidation = useCallback(
    debounce(async (slug) => {
      await validateSlug(slug, initialSlugValue)
    }, 500),
    [initialSlugValue],
  )

  function handleChangeSlug(e) {
    setClinicBrand((prev) => ({ ...prev, slug: e.target.value }))
    debSlugValidation(e.target.value)
  }

  function handleChangeStaff(eve, idx, staffTypeId, inputType) {
    setClinicBrand((prev) => {
      const currentValue = getValueFromDotOperatorString(clinicBrand, staffTypeId) || []
      const updatedValue = getUpdatedValueFromDotOperatorString(
        prev,
        staffTypeId,
        [...(currentValue || [])]?.map((item, index) =>
          index === idx
            ? {
                ...item,
                [inputType]: eve.target.value,
                edited: true,
              }
            : item,
        ),
      )

      return updatedValue

      // return {
      //   ...prev,
      //   [prospectType.id]: [...(prev?.[prospectType.id] || []), ''],
      // }
    })
  }

  function checkIfAProspectContactIsValid(prospectContact) {
    return isValidEmail(prospectContact?.email) || isValidPhoneNumber(`+${prospectContact?.mobile}`)
  }

  function checkIfAllProspectIsValid(prospectType) {
    const userContactArray = getValueFromDotOperatorString(clinicBrand, prospectType?.id) || []

    const validityArray = userContactArray?.map((prospectContact) => {
      if (!prospectContact?.email && !prospectContact?.mobile) {
        return false
      }
      if (prospectContact?.email) {
        if (!isValidEmail(prospectContact?.email)) {
          return false
        }
      }

      if (prospectContact?.mobile) {
        if (!isValidPhoneNumber(`${prospectContact?.mobile}`)) {
          return false
        }
      }
      return true
    })

    if (validityArray.includes(false)) {
      return false
    }

    const emailsToVerify = userContactArray
      ?.filter((userContact) => !!userContact?.email)
      ?.map((userContact) => userContact?.email)

    const hasUniqueEmails = !hasDuplicateStrings(emailsToVerify?.filter(email=>!!email))
    if (!hasUniqueEmails) {
      return false
    }

    const mobilesToVerify = userContactArray
      ?.filter((userContact) => !!userContact?.mobile)
      ?.map((userContact) => userContact?.mobile)

    const hasUniqueMobiles = !hasDuplicateStrings(mobilesToVerify?.filter(mob=>!!mob))

    console.log({emailsToVerify, mobilesToVerify})

    if (!hasUniqueMobiles) {
      return false
    }

    return true
  }

  function handleAddProspect(prospectType) {
    if (!checkIfAllProspectIsValid(prospectType)) {
      return
    }

    setClinicBrand((prev) => {
      const currentValue = getValueFromDotOperatorString(clinicBrand, prospectType?.id) || []
      const updateValue = getUpdatedValueFromDotOperatorString(prev, prospectType?.id, [
        ...(currentValue || []),
        {
          email: '',
          userId: '',
          id: '',
        },
      ])
      return updateValue

      // return {
      //   ...prev,
      //   [prospectType.id]: [...(prev?.[prospectType.id] || []), ''],
      // }
    })
  }

  function handleRemoveProspect(prospectType, idx) {
    setClinicBrand((prev) => {
      const currentValue = getValueFromDotOperatorString(prev, prospectType?.id) || []
      const updatedValue = getUpdatedValueFromDotOperatorString(
        prev,
        prospectType?.id,
        [...(currentValue || [])]?.filter((item, index) => index !== idx),
      )

      return updatedValue
    })
  }

  function handleSubmit(eve) {
    eve.preventDefault()
    saveClinicBrand()
  }

  const handleClick = () => {
    fileInputRef?.current?.click()
  }

  const handleFileUpload = async (event) => {
    const file = event?.target?.files[0] //getting the file

    if (!file) {
      return
    }

    const reader = new FileReader()
    reader.onload = () => {
      setTempImgUrl(reader.result)
    }
    reader.readAsDataURL(file) //for showing image without waiting for api response

    const formData = new FormData()
    formData?.append('file', file)

    setWaitingPictureUpload(true)

    try {
      const response = await axios.post(`${apiURL}/api/media/file/upload`, formData, {
        headers: {
          ...commonHeadersWeb,
          'ef-user-country-code': localStorage.getItem('countryCode'),
          'ef-app-language': sessionStorage.getItem('languageCode'),
        },
      })

      if (response?.status === 200) {
        const fileId = response?.data?.fileId
        setClinicBrand((prev) => ({
          ...prev,
          coverIcon: fileId,
        }))
        setWaitingPictureUpload(false)
        toast.success('Profile picture uploaded successfully')
      } else {
        setTempImgUrl(null)
        setWaitingPictureUpload(false)
        toast.error('Error uploading image')
      }
    } catch (error) {
      console.log(error)
      setTempImgUrl(null)
      setWaitingPictureUpload(false)
      toast.error('Error uploading image')
    }
    // Reset file input
    event.target.value = ''
  }

  async function getSuggestedSlug({ formData }) {
    const response = await getMPDataWithParams('/api/secure/cp/clinic-brand/slug/suggest', {
      title: formData?.brandName,
    })
    if (response?.status === 200) {
      setClinicBrand((prev) => ({
        ...prev,
        tempSlug: response?.data,
      }))
      debSlugValidation(response?.data)
    }
  }

  function slugFocusHandling() {
    if (!clinicBrand?.slug && !!clinicBrand?.tempSlug) {
      setClinicBrand((prev) => ({
        ...prev,
        slug: prev?.tempSlug || '',
      }))
    }
  }

  const debSlugSuggest = useCallback(
    debounce(async ({ formData }) => {
      await getSuggestedSlug({ formData })
    }, 500),
    [],
  )

  useEffect(() => {
    if (clinicBrand?.id && !editingProfileDetailsNotAllowed)
      getSuggestedSlug(clinicBrand?.brandName)
  }, [])

  useEffect(() => {
    if (initialSlugValue) {
    } else {
      setInitialSlugValue(clinicBrand?.slug)
      setSlugValid(clinicBrand?.slug || clinicBrand?.tempSlug)
    }
  }, [clinicBrand])

  useEffect(() => {
    if (!clinicBrand?.slug) {
      debSlugSuggest({ formData: clinicBrand })
    }
  }, [clinicBrand?.brandName])

  console.log({ clinicBrandLoading, slugValid })

  const coverIconUrl = clinicBrand?.coverIcon
    ? isValidHttpUrl(clinicBrand.coverIcon)
      ? clinicBrand.coverIcon
      : `${mediaURL}${clinicBrand.coverIcon}`
    : null

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={1}>
        {!Boolean(editingProfileDetailsNotAllowed) && (
          <>
            <Grid item xs={12}>
              <div style={{ marginBottom: '20px' }}>
                <StyledLabel>Brand Logo (Square Image)</StyledLabel>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                    marginTop: '10px',
                  }}
                >
                  <Box
                    sx={{
                      position: 'relative',
                      width: '120px',
                      height: '120px',
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                      overflow: 'hidden',
                      backgroundColor: '#f5f5f5',
                      cursor: 'pointer',
                      '&:hover': {
                        borderColor: '#7450aa',
                      },
                    }}
                    onClick={handleClick}
                  >
                    {coverIconUrl || tempImgUrl ? (
                      <img
                        src={tempImgUrl || coverIconUrl}
                        alt="Brand Logo"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: '100%',
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#999',
                        }}
                      >
                        <CameraAlt sx={{ fontSize: 40, mb: 1 }} />
                        <span style={{ fontSize: '12px' }}>Upload Logo</span>
                      </Box>
                    )}
                    {waitingPictureUpload && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        }}
                      >
                        <CircularProgress size={30} sx={{ color: '#fff' }} />
                      </Box>
                    )}
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 8,
                        right: 8,
                        backgroundColor: 'rgba(116, 80, 170, 0.9)',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: 'rgba(116, 80, 170, 1)',
                        },
                      }}
                    >
                      {coverIconUrl || tempImgUrl ? (
                        <Edit sx={{ fontSize: 18 }} />
                      ) : (
                        <CameraAlt sx={{ fontSize: 18 }} />
                      )}
                    </Box>
                  </Box>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                  />
                  <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                      Upload a square logo image for your clinic brand. This will be displayed
                      across the app where a placeholder image was shown.
                    </p>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <ClinicOnboardingInputComponentWithHTMLProps
                id="brandName"
                title="Brand Name"
                value={clinicBrand?.brandName}
                onChange={handleChange}
                placeholder="Ex: Dementrix Hair Clinics"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <ClinicOnboardingInputComponentWithHTMLProps
                id="brandShortName"
                title="Brand Short Name"
                placeholder="Ex: Dementrix"
                value={clinicBrand?.brandShortName}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <div className="d-flex flex-column justify-content-start align-items-stretch gap-1 w-100">
                <StyledLabel>URL for this brand: </StyledLabel>
                <BusinessOnboardingInputContainer
                  onClick={() => {
                    slugInputRef.current.focus()
                  }}
                  style={{ textDecoration: 'underline' }}
                >
                  <span>https://aumhum.com/clinic/</span>
                  <BusinessOnboardingInput
                    style={{
                      border: 'none',
                      width: '100%',
                      paddingLeft: 0,
                    }}
                    ref={slugInputRef}
                    type="text"
                    id={showTempSlug ? 'tempSlug' : 'slug'}
                    value={!showTempSlug ? clinicBrand?.slug : clinicBrand?.tempSlug}
                    onFocus={slugFocusHandling}
                    label={'Unique URL'}
                    onChange={(event) => {
                      handleChangeSlug(event)
                    }}
                  />
                </BusinessOnboardingInputContainer>
              </div>
            </Grid>
            {slugValidationLoading && (
              <div style={{ marginLeft: '5px' }}>Checking availability...</div>
            )}
            {clinicBrand?.slug && slugInvalidFormat && (
              <div style={{ color: 'red', marginLeft: '5px' }}>
                Please use lower case letters and hyphens only
              </div>
            )}
            {!slugInvalidFormat &&
              clinicBrand?.slug &&
              (slugValid
                ? !slugValidationLoading && (
                    <div style={{ color: 'green', marginLeft: '5px' }}>Looks good!</div>
                  )
                : !slugValidationLoading && (
                    <div style={{ color: 'red', marginLeft: '5px' }}>
                      Not available.{' '}
                      <span style={{ color: 'rgba(44, 56, 74, 0.95)' }}>
                        {/* {suggestedSlug && (
                        <>
                          Suggested:{' '}
                          <span
                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => {
                              setClinicBrand((prev) => ({
                                ...prev,
                                slug: suggestedSlug,
                              }))
                              setSlugValid(true)
                            }}
                          >
                            {suggestedSlug}
                          </span>
                        </>
                      )} */}
                      </span>
                    </div>
                  ))}
          </>
        )}

        {!Boolean(editingPeopleNotAllowed) && (
          <>
            <Grid item xs={12}>
              <h3>Add People</h3>
            </Grid>
            {/* Prospect Owner Email ID */}
            {/* Send Automatically? */}
            {!!brandOwnerUserData?.length && (
              <Grid item xs={12}>
                <h4 className="m-0">Owner:-</h4>
              </Grid>
            )}
            {brandOwnerUserData?.map((oData, idx) => {
              return (
                <Grid key={idx} item xs={12}>
                  {oData?.firstName}{' '}
                  {clinicBrand?.kycStatus === 'pending' ? (
                    <Chip size="small" label="Clinic KYC Pending" color="warning" sx={{ ml: 1 }} />
                  ) : (
                    ''
                  )}
                  {teacherData?.kycStatus === 'pending' ? (
                    <Chip size="small" label="Doctor KYC Pending" color="warning" sx={{ ml: 1 }} />
                  ) : (
                    ''
                  )}
                </Grid>
              )
            })}
            {/* Other Prospects prospectTypes: doctor, therapist, clinicAssistant */}
            <StaffOnboardingCards
              checkIfAProspectContactIsValid={checkIfAProspectContactIsValid}
              clinicBrand={clinicBrand}
              handleChangeProspects={handleChangeStaff}
              handleRemoveProspect={handleRemoveProspect}
              handleAddProspect={handleAddProspect}
              staffTypeValue={staffTypes?.admins}
              staffAccordionState={staffsAddordionState}
              setStaffAccordionState={setStaffAccordionState}
            />
            <Grid item xs={12}>
              <h4>In House Staff:-</h4>
            </Grid>
            {/* {Object.entries(prospectTypes).map(([key, prospectTypeValue]) => (
              <ProspectInputCards
                key={key}
                checkForDuplicateStrings={checkForDuplicateStrings}
                checkIfAProspectContactIsValid={checkIfAProspectContactIsValid}
                clinicBrand={clinicBrand}
                handleChangeProspects={handleChangeProspects}
                handleRemoveProspect={handleRemoveProspect}
                handleAddProspect={handleAddProspect}
                prospectTypeValue={prospectTypeValue}
                prospectsAccordionState={prospectsAccordionState}
                setProspectsAccordionState={setProspectsAccordionState}
              />
            ))} */}
            {/* WORKFORCE STAFF */}
            <StaffOnboardingCards
              checkIfAProspectContactIsValid={checkIfAProspectContactIsValid}
              clinicBrand={clinicBrand}
              handleChangeProspects={handleChangeStaff}
              handleRemoveProspect={handleRemoveProspect}
              handleAddProspect={handleAddProspect}
              setStaffAccordionState={setStaffAccordionState}
              staffAccordionState={staffsAddordionState}
              staffTypeValue={staffTypes?.doctor}
            />
            <StaffOnboardingCards
              checkIfAProspectContactIsValid={checkIfAProspectContactIsValid}
              clinicBrand={clinicBrand}
              handleChangeProspects={handleChangeStaff}
              handleRemoveProspect={handleRemoveProspect}
              handleAddProspect={handleAddProspect}
              setStaffAccordionState={setStaffAccordionState}
              staffAccordionState={staffsAddordionState}
              staffTypeValue={staffTypes?.therapist}
            />
            <StaffOnboardingCards
              checkIfAProspectContactIsValid={checkIfAProspectContactIsValid}
              clinicBrand={clinicBrand}
              handleChangeProspects={handleChangeStaff}
              handleRemoveProspect={handleRemoveProspect}
              handleAddProspect={handleAddProspect}
              setStaffAccordionState={setStaffAccordionState}
              staffAccordionState={staffsAddordionState}
              staffTypeValue={staffTypes?.clinicAssistant}
            />
          </>
        )}
      </Grid>
      <BusinessOnboardingSubmitButton
        disabled={clinicBrandLoading || !slugValid}
        type="submit"
        style={{ margin: '20px 0px' }}
      >
        <span>{clinicBrandLoading ? 'Loading latest details...' : 'Continue'}</span>
        {savingClinicBrand && <Spinner animation="border" variant="light" size="sm" />}
      </BusinessOnboardingSubmitButton>
    </form>
  )
}

// switch (type) {
//   case prospectTypes.doctor.id:
//     setClinicBrand((prev) => ({
//       ...prev,
//       prospectDoctorEmailIds: prev.prospectDoctorEmailIds.map((item, index) =>
//         index === idx ? eve.target.value : item,
//       ),
//     }))
//     break
//   case prospectTypes.therapist.id:
//     setClinicBrand((prev) => ({
//       ...prev,
//       prospectTherapistEmailIds: prev.prospectTherapistEmailIds.map((item, index) =>
//         index === idx ? eve.target.value : item,
//       ),
//     }))
//     break
//   case prospectTypes.clinicAssistant.id:
//     setClinicBrand((prev) => ({
//       ...prev,
//       prospectClinicAssistantEmailIds: prev.prospectClinicAssistantEmailIds.map((item, index) =>
//         index === idx ? eve.target.value : item,
//       ),
//     }))
//     break
//   default:
//     break
// }

{
  /* <Grid item xs={12} key={key}>
<SingleExpandAccordionWrapper
  accordionSummaryHeading={
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      <span>{prospectTypeValue.title}</span>
      {(
        getValueFromDotOperatorString(clinicBrand, prospectTypeValue?.id) || []
      )?.filter((prospectEmail) => {
        return (
          (!!prospectEmail?.email && isValidEmail(prospectEmail?.email)) ||
          (!!prospectEmail?.mobile &&
            isValidPhoneNumber(`+${prospectEmail?.mobile}`))
        )
      })?.length > 0 ? (
        <Chip
          size="small"
          label={
            [
              ...new Set(
                getValueFromDotOperatorString(clinicBrand, prospectTypeValue?.id) ||
                  [],
              ),
            ]?.filter((prospectContact) =>
              checkIfAProspectContactIsValid(prospectContact),
            )?.length
          }
        />
      ) : (
        <Chip size="small" label="None" />
      )}
    </div>
  }
  expandedItemIdentifier={prospectTypeValue?.id}
  isExpanded={prospectsAccordionState === prospectTypeValue?.id}
  expandOnChange={() => setProspectsAccordionState(prospectTypeValue?.id)}
>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '17px' }}>
    {(getValueFromDotOperatorString(clinicBrand, prospectTypeValue?.id) || [])?.map(
      (item, idx) => (
        <ClinicBrandOnboardingProspectInput
          key={idx}
          idx={idx}
          prospectTypeValue={prospectTypeValue}
          checkForDuplicateEmailIds={checkForDuplicateStrings}
          handleChangeProspects={handleChangeProspects}
          handleRemoveProspect={handleRemoveProspect}
          item={item}
          parentObject={clinicBrand}
        />
      ),
    )}
    <StyledAddStaffButton
      style={{ alignSelf: 'flex-end' }}
      onClick={() => handleAddProspect(prospectTypeValue)}
    >
      {(getValueFromDotOperatorString(clinicBrand, prospectTypeValue?.id) || [])
        ?.length > 0
        ? 'Add Another'
        : 'Add One'}
    </StyledAddStaffButton>
  </div>
</SingleExpandAccordionWrapper>
</Grid> */
}

// {/* will change to the new data type of usercontact */}
// {Array.isArray(clinicBrand?.attachedDoctorUserIds) &&
//   clinicBrand?.attachedDoctorUserIds?.length > 0 && (
//     <>
//       <div style={{ marginTop: '20px', width: '100%' }}></div>
//       <Grid item xs={12}>
//         <h4>Approved Doctors</h4>
//       </Grid>
//       <div>
//         {clinicBrand?.attachedDoctorUserIds?.map((item, index) => {
//           const thisUser = ownerData?.ownerBrandPeopleUserSummary?.[
//             clinicBrandId
//           ]?.find((person) => person?.userId === item)
//           return <li key={index}>{thisUser?.firstName || thisUser?.name}</li>
//         })}
//       </div>
//     </>
//   )}
// {Array.isArray(clinicBrand?.attachedTherapistUserIds) &&
//   clinicBrand?.attachedTherapistUserIds?.length > 0 && (
//     <>
//       <div style={{ marginTop: '20px', width: '100%' }}></div>
//       <Grid item xs={12}>
//         <h4>Approved Therapists</h4>
//       </Grid>
//       <div>
//         {clinicBrand?.attachedTherapistUserIds?.map((item, index) => {
//           const thisUser = ownerData?.ownerBrandPeopleUserSummary?.[
//             clinicBrandId
//           ]?.find((person) => person?.userId === item)
//           return <li key={index}>{thisUser?.firstName || thisUser?.name}</li>
//         })}
//       </div>
//     </>
//   )}
// {Array.isArray(clinicBrand?.attachedClinicAssistantUserIds) &&
//   clinicBrand?.attachedClinicAssistantUserIds?.length > 0 && (
//     <>
//       <div style={{ marginTop: '20px', width: '100%' }}></div>
//       <Grid item xs={12}>
//         <h4>Approved Clinic Assistants</h4>
//       </Grid>
//       <div>
//         {clinicBrand?.attachedClinicAssistantUserIds?.map((item, index) => {
//           const thisUser = ownerData?.ownerBrandPeopleUserSummary?.[
//             clinicBrandId
//           ]?.find((person) => person?.userId === item)
//           return <li key={index}>{thisUser?.firstName || thisUser?.name}</li>
//         })}
//       </div>
//     </>
//   )}
